import React from "react";
import Invoice from "../../../components/StoreModule/Invoice/invoice.component";

export default class InvoiceScreen extends React.Component {
  render() {
    return <Invoice />;
  }
}
